import ConfigurableBackground from './_configurable-background.js'
import Hideable from './_hideable.js'
import HideablePane from './_hideable-pane.js'
import ApplicationMenu from './_application-menu.js'
import MainNavigationBar from './_main-navigation-bar.js'
import SystemInitialisation from './_system-initialisation.js'

export default {
  name: 'ApplicationHeader',
  values: {
    layout: 'normal',
    style: {
      $mixin: [
        {
          configSet: ConfigurableBackground,
        },
      ],
    },
    stickyHeader: false,
    _mobile_stickyHeader: true,
    mainNavigationBar: {
      configSet: Hideable,
      configValues: {
        _mobile_hide: true,
      },
    },
    appBannerView: {
      configSet: Hideable,
      configValues: {
        _native_hide: true,
      },
    },
    cookieConsentView: {
      configSet: Hideable,
      configValues: {
        _native_hide: true,
      },
    },
    headerContentContainer: {
      $mixin: [
        {
          configSet: ConfigurableBackground,
        },
      ],
    },
    headerContainer: {
      position: 'sticky',
      top: 'env(safe-area-inset-top, 0px)',
      touchAction: 'none',
    },
    cookieConsentWrapper: {
      position: 'fixed',
      width: '100%',
      zIndex: '999',
      _mobile_zIndex: '0',
      _mobile_position: 'relative',
    },
    cookieConsentContainer: {
      configSet: HideablePane,
      configValues: {
        enableTransitions: false,
      },
    },
    appBannerContainer: {
      configSet: HideablePane,
      configValues: {
        enableTransitions: false,
        style: {
          base: {
            padding: '0 8px 0 0',
          },
        },
      },
    },
    normalLayout: {
      applicationMenu: {
        configSet: ApplicationMenu,
        configValues: {},
      },
      mainNavigationBar: {
        configSet: MainNavigationBar,
        configValues: {
          searchPosition: 'right',
          searchControllerView: {
            searchView: {
              style: {
                searchBox: {
                  position: 'relative',
                },
              },
              searchResultsPopup: {
                container: {
                  style: {
                    right: '8px',
                  },
                },
                arrowheadOffset: '-8px',
              },
            },
          },
        },
      },
    },
    compactLayout: {
      applicationMenu: {
        configSet: ApplicationMenu,
        configValues: {
          layout: 'single-row',
        },
      },
      mainNavigationBar: {
        configSet: MainNavigationBar,
        configValues: {
          searchPosition: 'left',
          searchControllerView: {
            searchView: {
              style: {
                searchBox: {
                  position: 'absolute',
                },
              },
              searchResultsPopup: {
                container: {
                  style: {
                    left: '8px',
                  },
                },
              },
            },
          },
          buttonPosition: 'right',
          rightContainer: {
            style: {
              flexGrow: 0,
              flexBasis: '20%',
            },
          },
          linkButtons: {
            container: {
              style: {
                justifyContent: 'center',
                padding: '0 0 0 20%',
              },
            },
          },
          sessionTime: {
            layoutDirection: 'horizontal',
          },
        },
      },
    },
    showSystemInitialisation: true,
    _mobile_showSystemInitialisation: false,
    systemInitialisation: {
      configSet: SystemInitialisation,
      configValues: {},
    },
    systemInitialisationContainer: {
      configSet: HideablePane,
      configValues: {
        enableTransitions: false,
      },
    },
  },
  meta: {
    extendable: false,
  },
}
